import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Skill } from "@/model";
import { useSkills } from "@/query/skill";
import { useTransferIntent } from "@/query/intent";
import { useAgentId, useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { errorToast, successToast } from "@/component/Toast";
import { DropdownGroup, DropdownButton, DropdownItem, DropdownItems } from "@/component/input";


export const INTENT_TRANSFER_MODAL_ID = "intent-transfer-modal-id";

const IntentTransferModal: React.FC<{skillId?: number}> = ({ skillId }) => {
    const intl = useIntl();
    const modal = useModal();
    const agentId = useAgentId();

    const [validated, setValidated] = useState<boolean>(true);
    const [destSkill, setDestSkill] = useState<Skill | undefined>();

    const { mutateAsync: transferIntents, isPending: isTransferring } = useTransferIntent(agentId, skillId);
    const { data: skills } = useSkills(agentId);

    const intentIds: string[] = modal.getData(INTENT_TRANSFER_MODAL_ID);

    const onClickConfirm = async () => {
        setValidated(false);
        if (!destSkill) {
            return;
        }

        await transferIntents({
                skill_id: destSkill.id,
                intent_ids: intentIds
            })
            .then(() => {
                setValidated(true);
                successToast(intl.formatMessage({ id: "t001" }));
                modal.close(INTENT_TRANSFER_MODAL_ID);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t002" }));
            });
    };

    return (
        <Modal id={INTENT_TRANSFER_MODAL_ID}
               size="sm"
               title={intl.formatMessage({ id: "i03067" })}
               onClose={() => {
                   setValidated(false);
                   setDestSkill(undefined);
               }}
        >
            <div className="modal-body">
                <DropdownGroup width={328}>
                    <DropdownButton isSelected={!!destSkill}
                                    invalid={validated && !destSkill}
                    >
                        {destSkill?.name ?? intl.formatMessage({ id: "i03068" })}
                    </DropdownButton>
                    <DropdownItems>
                        {skills?.map((skill, index) => (
                            <DropdownItem key={skill.id}
                                          isOdd={index % 2 === 1}
                                          onClick={() => setDestSkill(skill)}
                            >
                                {skill.name}
                            </DropdownItem>
                        ))}
                    </DropdownItems>
                </DropdownGroup>

                <div className="modal-btn-group">
                    <Button size="sm"
                            variant="secondary"
                            disabled={isTransferring}
                            onClick={() => modal.close(INTENT_TRANSFER_MODAL_ID)}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button size="sm"
                            variant="primary"
                            disabled={isTransferring}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default IntentTransferModal;
